import { AnalyticsBrowser } from '@segment/analytics-next'
import { detectEnvironmentFromUrl, Environment, SEGMENT_KEYS } from 'shared/config/config'

let analytics: AnalyticsBrowser | null = null
export function getAnalytics() {
  if (analytics) return analytics

  analytics = AnalyticsBrowser.load({
    writeKey: detectEnvironmentFromUrl() === Environment.PRODUCTION ? SEGMENT_KEYS.PROD : SEGMENT_KEYS.DEV,
  })

  return analytics
}

export function captureEvent(
  event: string,
  metadata: Record<string, any> = {},
  options?: SegmentAnalytics.SegmentOpts
) {
  if (detectEnvironmentFromUrl() !== Environment.PRODUCTION) {
    // eslint-disable-next-line no-console
    console.log(`Tracking analytics event: ${event}, metadata:`, metadata, options)
    return
  }

  const analytics = getAnalytics()

  // This should be the only usage of this call in the app
  analytics.track(event, metadata, options)
}
